import axios from 'axios'
import { Notification, Message } from 'element-ui'
import Vue from 'vue'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: '',
  // 超时
  timeout: 100000
})

// request拦截器
window.axiosPromiseArr = []
service.interceptors.request.use(config => {
  NProgress.start()
  config.cancelToken = new axios.CancelToken(
    cancel => window.axiosPromiseArr.push({ cancel })
  )
  return config
}, error => {
  console.log(error)
  // Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(res => {
  NProgress.done()
  // 未设置状态码则默认成功状态
  const code = res.data.code || res.code || 200;
  // 获取错误信息
  const msg = res.data.message || res.data.msg || res.message
  if (code === 500) {
    Message({
      message: msg,
      type: 'error'
    })
    return Promise.reject(new Error(msg))

  } else if (code == -1) {
    return res.data
  } else if (code == 200) {
    return res.data
  } else {
    return Promise.reject('error sign')
  }
},
  error => {
    // console.log('err' + error)
    let { message } = error;
    // if (message == "Network Error") {
    //   message = "后端接口连接异常";
    // }
    // else if (message.includes("timeout")) {
    //   message = "系统接口请求超时";
    // }
    // else if (message.includes("Request failed with status code")) {
    //   message = "系统接口" + message.substr(message.length - 3) + "异常";
    // }
    Message({
      message: 'システム異常',
      type: 'error',
      duration: 2 * 1000
    })
    NProgress.done()

    return Promise.reject(error)
  }
)

export default service
